import * as Sentry from "@sentry/react";
import React from "react";
import { createRoot } from "react-dom/client";
import { FirebaseProvider } from "./context/firebase-context";
import { PostHogProvider } from "posthog-js/react";
import App from "./App.tsx";
import "./index.css";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_VERCEL_TARGET_ENV || "local",
  integrations: [Sentry.browserTracingIntegration(), Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] })],
  enableLogs: true,
  sendDefaultPii: true,
  tracesSampleRate: 1.0,
});

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <PostHogProvider
      apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
      options={{
        api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
        defaults: "2026-01-30",
        capture_exceptions: true, // This enables capturing exceptions using Error Tracking, set to false if you don't want this
        debug: import.meta.env.MODE === "development",
      }}
    >
      <FirebaseProvider>
        <App />
      </FirebaseProvider>
    </PostHogProvider>
  </React.StrictMode>,
);
